// /about — the one static page with REAL copy rather than a placeholder. It
// describes what the platform is and the two ideas the rest of the product
// follows from (per-establishment accounts linked by a consented identity, and
// family access as a directed permission). Nothing here is a claim we cannot
// point at code for.

import { useTranslation } from 'react-i18next';
import PublicPage, { Section } from './PublicPage';

export default function About() {
  const { t } = useTranslation('publicPages');
  return (
    <PublicPage
      testId="about-page"
      title={t('publicPages.about_title')}
      lead={t('publicPages.about_lead')}
    >
      <Section heading={t('publicPages.about_h1')} testId="about-what">
        <p>{t('publicPages.about_p1')}</p>
      </Section>
      <Section heading={t('publicPages.about_h2')} testId="about-ideas">
        <p>{t('publicPages.about_p2')}</p>
        <p>{t('publicPages.about_p3')}</p>
      </Section>
      <Section heading={t('publicPages.about_h3')} testId="about-how">
        <p>{t('publicPages.about_p4')}</p>
      </Section>
      <Section heading={t('publicPages.about_h4')} testId="about-name">
        <p>{t('publicPages.about_p5')}</p>
      </Section>
    </PublicPage>
  );
}
